import React from 'react';
import ssoImg from "./../../../../assets/images/sso-img.png"; // Adjust the path as necessary
function OverviewTab() {
  return (
    <>
    <div className="service-title font-700 mb-3">
                {" "}
                SERVICES{" "}
                <span className="text-orange-ef3e33 font-400">
                  {/* {" "}<b>SERVICES </b> */}
                {" "} SEAFARER OVERVIEW
                </span>
              </div>
              <div className="service-box mb-5 mb-sm-4">
                The Centre for Seafarers is responsible for ensuring that all
                services to seafarers offered by SAMSA and SAMSA
                accredited/approved providers are quality services and
                consistent through the different offices. The Centre is made of
                largely three units:
              </div>

              <div className="row g-3 g-sm-4 g-md-5">
                <div className="col-lg">
                  <div className='x-scroll mb-4'>
                      <div className='service-block-wrap'>
                      <div className="service-block">
                        <div className="icon first">
                          <i></i>
                        </div>
                        <p>
                          Office of the
                          <br /> Chief Examiner
                        </p>
                      </div>
                      <div className="service-block">
                        <div className="icon second">
                          <i></i>
                        </div>
                        <p>
                          Office of the
                          <br /> Registrar of Seafarers
                        </p>
                      </div>
                      <div className="service-block">
                        <div className="icon third">
                          <i></i>
                        </div>
                        <p>
                          Office of the
                          <br /> Welfare Office
                        </p>
                      </div>
                  </div>
                  </div>
                  
             
                  <div className="bg-gray-de p-4 rounded">
                    {/* <p className="mb-3">
                      The Office of the Chief Examiner, together with the
                      Certification office, are responsible for the education,
                      training, assessment and certification of seafarers.{" "}
                    </p> */}
                     <p className="mb-3">
                      The Office of the Chief Examiner, together with the Office of the Registrar of Seafarers, are responsible for the education, training, assessment, and certification of seafarers.{" "}
                    </p>

                    <p className="mb-3">
                      The education, training, assessment and certification of
                      seafarers services are achieved by setting minimum
                      standards that are compliant with the International
                      Convention on Standards of Training, Certification and
                      Watchkeeping for Seafarers, 1978, as amended (STCW
                      Convention), and the Merchant Shipping (Training,
                      Certification and Safe Manning) Regulations 2021(the
                      Regulations).
                    </p>

                    <p>
                      The STCW Convention set the minimum standards for the
                      training and certification through the Seafarers'
                      Training, Certification and Watchkeeping Code (STCW Code).
                    </p>
                  </div>
                </div>
                <div className="col-lg-auto">
                  <img src={ssoImg} className="img-fluid" alt="" />
                </div>
              </div>
    </>
  )
}

export default OverviewTab